/*global GridAndFormController, GridController, FormController*/
/** @this {GridAndFormController} */
var TrackedSmsEmbeddable = function(options){    
    GridAndFormController.call(this,"iz_tracked_sms", 
    {
        grid: {
            directory: "views/tracked",
            name: "trackedSmsGrid",
            canCreate: false
        },
        form: {
            directory: "views/tracked",
            name: "trackedSmsForm",
            joinFetch: [
                { otherTable: "iz_tracked_sms_event", name: "events", type:"2many"}
            ],
            buttonsHTML: FormController.globalsOptions.buttonsHTML
                .replace('id="btCreate"', 'id="btCreate" data-show-if="false"')
                .replace('id="btModify"', 'id="btModify" data-show-if="false"')
                .replace('id="btDelete"', 'id="btDelete" data-show-if="false"'),
            
        },
    }) ;


    this.gridController.prepareDataOnEnter = function(data, callback){
        if(data){
            //if we receive some data, we update the grid search options with a new
            //search criteria
            //the this.options object will be filled from HTML markup
            this.searchOptions = {
                res_model: options.searchmodel
            } ;
            this.searchOptions.res_id = data.id ;
        }
        //call the normal function on the grid super class to continue with standard grid behavior
        GridController.prototype.prepareDataOnEnter.call(this, data, callback) ;
    } ;
} ;

TrackedSmsEmbeddable.prototype = Object.create(GridAndFormController.prototype);
TrackedSmsEmbeddable.prototype.constructor = TrackedSmsEmbeddable;

module.exports = TrackedSmsEmbeddable ;